import React, { useState } from 'react';
import { lbl, inp, row2, row3, DateInput } from './shared';
// Name fields (first/middle/last) live in ContactInfo.js — see that file for rationale.

const FEET = [3, 4, 5, 6, 7];
const INCHES = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

function parseHeight(val) {
  const raw = String(val || '').trim();
  const oldFormat = raw.match(/^(\d+)'(\d+)"?$/);
  if (oldFormat) return { ft: oldFormat[1], in: oldFormat[2] };

  const totalInches = Number.parseInt(raw, 10);
  if (Number.isFinite(totalInches) && totalInches > 0) {
    return {
      ft: String(Math.floor(totalInches / 12)),
      in: String(totalInches % 12),
    };
  }

  return { ft: '', in: '' };
}

function HeightSelect({ value, onChange }) {
  const { ft, in: inch } = parseHeight(value);

  function update(newFt, newIn) {
    if (!newFt) { onChange(''); return; }
    const resolvedIn = newIn !== '' ? newIn : '0';
    onChange(String((Number(newFt) * 12) + Number(resolvedIn)));
  }

  const sel = {
    ...inp,
    cursor: 'pointer',
    appearance: 'auto',
    width: 'auto',
    flex: 1,
  };

  return (
    <div style={{ display: 'flex', gap: 8 }}>
      <select style={sel} value={ft} onChange={e => update(e.target.value, inch)}>
        <option value="">ft</option>
        {FEET.map(f => <option key={f} value={f}>{f} ft</option>)}
      </select>
      <select style={sel} value={inch} onChange={e => update(ft, e.target.value)}>
        <option value="">in</option>
        {INCHES.map(i => <option key={i} value={i}>{i} in</option>)}
      </select>
    </div>
  );
}

export default function PersonalInfo({ data, onChange }) {
  const [showSSN, setShowSSN] = useState(false);

  return (
    <div>
      <div style={row2}>
        <div>
          <label style={lbl}>Date of Birth</label>
          <DateInput style={inp} value={data.dob} onChange={v => onChange('dob', v)} />
        </div>
        <div>
          <label style={lbl}>Social Security Number</label>
          <div style={{ position: 'relative' }}>
            <input
              style={{ ...inp, paddingRight: 40 }}
              type={showSSN ? 'text' : 'password'}
              placeholder="XXX-XX-XXXX"
              value={data.ssn}
              autoComplete="off"
              onChange={e => {
                const digits = e.target.value.replace(/\D/g, '').slice(0, 9);
                let formatted = digits;
                if (digits.length > 5) formatted = `${digits.slice(0,3)}-${digits.slice(3,5)}-${digits.slice(5)}`;
                else if (digits.length > 3) formatted = `${digits.slice(0,3)}-${digits.slice(3)}`;
                onChange('ssn', formatted);
              }}
            />
            <button
              type="button"
              onClick={() => setShowSSN(v => !v)}
              title={showSSN ? 'Hide SSN' : 'Show SSN'}
              style={{
                position: 'absolute', right: 10, top: '50%',
                transform: 'translateY(-50%)',
                background: 'none', border: 'none',
                cursor: 'pointer', padding: 2,
                color: '#7a99b8', lineHeight: 0,
              }}
            >
              {showSSN ? (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                  <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                  <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              ) : (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      <div style={row3}>
        <div>
          <label style={lbl}>Height</label>
          <HeightSelect value={data.height} onChange={v => onChange('height', v)} />
        </div>
        <div>
          <label style={lbl}>Weight (lbs)</label>
          <input style={inp} placeholder="e.g. 165" value={data.weight} onChange={e => onChange('weight', e.target.value)} />
        </div>
        <div>
          <label style={lbl}>Gender</label>
          <select
            style={{ ...inp, cursor: 'pointer', appearance: 'auto', color: data.gender ? '#1a3364' : '#aaa' }}
            value={data.gender || ''}
            onChange={e => onChange('gender', e.target.value)}
          >
            <option value="" disabled>Select…</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </div>
      </div>
    </div>
  );
}
